/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Sc_MemoryInputs */

const en_tut_sc_memory = /** @type {(inputs: Tut_Sc_MemoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jump to Company memory`)
};

const id_tut_sc_memory = /** @type {(inputs: Tut_Sc_MemoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lompat ke Memori perusahaan`)
};

/**
* | output |
* | --- |
* | "Jump to Company memory" |
*
* @param {Tut_Sc_MemoryInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_sc_memory = /** @type {((inputs?: Tut_Sc_MemoryInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Sc_MemoryInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_sc_memory(inputs)
	return en_tut_sc_memory(inputs)
});